
<div class="head">
  <div class="title">{{title}}</div>
</div>

<div class="wrap">
  <div class="content">
    <div class="heading" *ngIf="!hideClause">
      <div class="cause-tags">
        <div *ngFor="let item of causes; index as i" class="tag-wrap" [ngClass]="{'active': selectedCauses.includes(item?.cause)}" (click)="filterCause(item?.cause)" mat-ripple>
          <div class="tag">
            <div class="icon"><em class="material-icons">{{item?.icon}}</em></div>
            <div class="title">{{item?.text}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="cards" *ngIf="fundraisers.length > 0 && !fundraiserLoading">
        <ng-container *ngIf="!useGlide">
          <div class="swiper-container" [swiper]="config">
            <div class="swiper-wrapper">
              <div *ngFor="let item of fundraisers" class="card swiper-slide">
                <app-fundraiser-card [fundraiser]="item" [eventInfo]="eventInfo" />
              </div>
              <div class="card swiper-slide see-more-card" *ngIf="!freqVisitedCampaigns?.length" matRipple routerLink="/crowdfunding/fundraisers">
                <div class="title">See more</div>
              </div>
            </div>
            <div class="navButtons" *ngIf="customNav && freqVisitedCampaigns?.length > 3">
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="useGlide">
          <ngx-glide [arrowLeftTemplate]="(customNav && (freqVisitedCampaigns?.length > 3 || fundraisers?.length > 3) && arrowLeftTemplate) || null" 
          [arrowRightTemplate]="(customNav && (freqVisitedCampaigns?.length > 3 || fundraisers?.length > 3) && arrowRightTemplate) || null" [showArrows]="(freqVisitedCampaigns?.length > 3 || fundraisers?.length > 3)" [showBullets]="false" [perView]="3" [bound]="true" [dragThreshold]="true" arrowLeftLabel="" arrowRightLabel="">
            <div class="glide_card" *ngFor="let item of fundraisers">
              <app-fundraiser-card [fundraiser]="item" [eventInfo]="eventInfo" />
            </div>
          </ngx-glide>
          <ng-template #arrowLeftTemplate>
            <div class="custom-arrow custom-arrow-left">
              <mat-icon class="btn-clr">chevron_left</mat-icon>
            </div>
          </ng-template>
          <ng-template #arrowRightTemplate>
            <div class="custom-arrow custom-arrow-right">
              <mat-icon class="btn-clr">chevron_right</mat-icon>
            </div>
          </ng-template>
          <button mat-button class="view-all-fundraisers-cta" matRipple routerLink="/crowdfunding/fundraisers">
            <div class="title">View all Fundraisers<mat-icon class="btn-clr">arrow_forward</mat-icon></div>
          </button>
      </ng-container>
      </div>
      <div class="no-campaign-wrapper" *ngIf="fundraisers.length === 0 && !fundraiserLoading">
        <div class="img-wrapper">
          <img src="/assets/images/browse-campaign/no-results.png" alt="no result" />
        </div>
        <div class="content">
          <div class="title">
            No results found
          </div>
          <div class="sub-title">
            Try adjusting your search filters to find what you are looking for.
          </div>
        </div>
      </div>
      <div class="fundraiser-loading" *ngIf="fundraiserLoading">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </div>
  </div>
</div>